import React, {useEffect, useRef, useState} from "react";
import {
    Tab,
    Accordion,
    Tabs,
    Table, ButtonGroup, ToggleButton, Button, Form,
    Container,
    Row,
    Col,
    InputGroup,
    DropdownButton,
    Dropdown
} from "react-bootstrap";
import axios from "axios";
import {Link, useNavigate} from "react-router-dom";
import {useAppUniqueToken} from "../../hooks/useAppUniqueToken";
import {useSanctum} from "react-sanctum";
import SendConfirmation from "../modals/SendConfirmation";
import RemoveConfirmation from "../modals/RemoveConfirmation";

import {useStockStorage} from "../../hooks/useStockStorage";

import {loungeData} from "../../config/types";
import LoadingSpinner from "./LoadingSpinner";
import {useTranslation} from "react-i18next";
import {toast} from "react-custom-alert";

import {
    defaultNONE,
    defaultEMPTY,
    defaultMomentDateFormat,
    previousYear,
    displayYear
} from "../../config/global";
import moment from 'moment';

import JSONRegions from '../../../../json/databasecomuni/italy_regions.json'
import JSONProvincies from '../../../../json/databasecomuni/italy_provincies.json'
import { useToolkit } from "../../hooks/useToolkit";
import { useEmailStorage } from "../../hooks/useEmailStorage";

interface IProps {
    data: loungeData
}

const SubscriptionsAccordion = () => {

    const { t } = useTranslation();
    
    const { setSessionStock, removeNewSessionStock, setSessionStockRegion, setSessionStockProvince, setStockStorageToken, removeStockStorageToken } = useStockStorage();
    const { getAppUniqueToken, setAppUniqueToken } = useAppUniqueToken();
    const {setCurrentTab, getCurrentTab, removeCurrentTab, removeCurrentQuote, decodeRegione, getLastYearsOptions} = useToolkit();
    const {removeEmailStorageSent, setEmailStorageSent, emailStorageSent} = useEmailStorage();
    
    const navigate = useNavigate();
    const { user } = useSanctum();

    const [showRemoveModal, setShowRemoveModal] = useState(false);
    const [customID, setCustomID] = useState<string>()
    const [customToken, setCustomToken] = useState<string>(getAppUniqueToken)
    const [showSendModal, setShowSendModal] = useState(false);

    const [isLoading, setLoading] = useState(false)
    const isLoadingRef = useRef(false);
    const hasMounted = useRef(false);

    const [data, setData] = useState<loungeData | null>(null)
    const [page, setPage] = useState('1');

    const [jsonRegion] = useState(JSONRegions.italy_regions);
    const [jsonProvince, setJSONProvince] = useState(JSONProvincies.italy_provincies);

    const [region, setRegion] = useState(defaultEMPTY);
    const [province, setProvince] = useState(defaultEMPTY);
    const [customSearch, setCustomSearch] = useState(defaultEMPTY);
    const [yearSearch, setYearSearch] = useState(displayYear.toString());
    const [showRemoveFiltersButton, setShowRemoveFiltersButton] = useState(false);
    const [removeFilters, setRemoveFilters] = useState(false);
    
    const [radioValue, setRadioValue] = useState('STATUS_CLOSED');


    useEffect(() => {
        removeStockStorageToken();
        setYearSearch(displayYear.toString());
        hasMounted.current = true;
        getLoungeData();
    }, []);

    const getLoungeData = async () => {
        if (isLoadingRef.current) return;

        isLoadingRef.current = true;
        setLoading(true);

        let _url = 'api/lounge';
        if(page && parseInt(page) > 1) {
            _url = _url +'?page='+page;
        }

       const payload = {
            region,
            province,
            customSearch,
            radioValue,
            yearSearch
        };


        //alert('getLoungeData: ' + JSON.stringify(payload));


        let loungeData = await axios.post(_url, payload, {
            headers: {
                'Accept': 'application/json'
            }
        }).then(response => {
            setData(response.data.lounge);
            setLoading(false);
            isLoadingRef.current = false;
        }).catch(() => {
            setLoading(false);
            isLoadingRef.current = false;
        });
    };

    useEffect(() => {
        if (!hasMounted.current) return;
        getLoungeData();
    }, [page])


    const fetchNextPrevTasks = (link: any) => {
        if(!isLoading) {
            const url = new URL(link);
            setPage(url.searchParams.get('page')!);
        }
    }

    const renderPaginationLinks = () => {
        
        return <ul className="pagination float-end">
            {
                
                data?.stocks.links?.map((link: { active: any; url: any; label: string; }, index: React.Key | null | undefined) => (
                    <li key={index} className="page-item">
                        <a style={{cursor: 'pointer'}} className={`page-link ${link.active ? 'active' : ''}`} 
                            onClick={() => fetchNextPrevTasks(link.url)}>
                            {
                                link.label.match('next') ? '>'
                                : link.label.match('previous') ? '<'
                                : link.label.replace('&laquo;', '').replace('&raquo;', '')
                            }
                        </a>
                    </li>
                ))
                
            }
        </ul>
    }


    const handleTrashStock = (id:string) => {
        setCustomID(id);
        setShowRemoveModal(true);
    };
    const handleRemove = (id:string, token:string) => {
        setCustomID(id);
        setCustomToken(token);
        setShowRemoveModal(true);
    };

    const handleSend = (token:string) => {

        //alert('handleSend: ' + token);
        //alert('/summary: replace true');

        setStockStorageToken(token);
        navigate('/summary');

        /*
        navigate("/summary", {
            replace: true,
            state: {
                token: token
            },
        });
        */

        //setShowSendModal(true);
    };

/*
    const handleDownloadReceipt = (token:string) => {
        const payload = {
            uaToken: token
        };

        //alert(token);

        axios.get('/api/download-receipt/' + token)
            .then(() => {
                //alert("REMOVE success");
                //location.reload();
            }).catch(error => {
            console.log(error);
            toast.error(t('messages.defaultErrorMessage'));
        });
    };

    const inputStockToken = useRef<HTMLInputElement>(null)
    function handleSubmit(e: any, stockToken: string){

        const f = e.currentTarget;
        e.preventDefault();
        e.stopPropagation();

        axios.get('/api/download-receipt/' + stockToken)
            .then(() => {
                //alert("REMOVE success");
                //location.reload();
                toast.success('FILE OK!');
            }).catch(error => {
            console.log(error);
            toast.error(t('messages.defaultErrorMessage'));
        });
    }
*/
    
    const [checked, setChecked] = useState(false);

    const radios = [
        { name: 'Inviate', value: 'STATUS_CLOSED' },
        { name: 'Salvate', value: 'STATUS_SAVED' },
        { name: 'Eliminate', value: 'STATUS_DELETED' },
    ];

    const handleOnChangeRegion = (e: any) => {
        setRegion(e.target.value);
        //getLoungeData();
    }
    const handleOnChangeProvince = (e: any) => {
        setProvince(e.target.value);
        //getLoungeData();
    }
    const handleOnChangeStatus = (e: any) => {
        setRadioValue(e.currentTarget.value);
        //getLoungeData();
    }

    useEffect(() => {
        if(region && region !== defaultNONE && region !== defaultEMPTY) {
            setJSONProvince(JSONProvincies.italy_provincies.filter(x => x.id_regione === region));
        }
        else {
            setJSONProvince(JSONProvincies.italy_provincies);
        }
        if (!hasMounted.current) return;
        handleSubmitFilters(null);
    }, [region])
    useEffect(() => {
        if (!hasMounted.current) return;
        handleSubmitFilters(null);
    }, [province])

    useEffect(() => {

        let b = (region && region !== defaultNONE && region !== defaultEMPTY)

        if(!b)
            b = (province && province !== defaultNONE && province !== defaultEMPTY)

        if(!b)
            b = (customSearch !== defaultEMPTY)

        if(!b)
            b = (yearSearch !== defaultEMPTY)
        
        setShowRemoveFiltersButton(b);

    }, [region, province, customSearch, radioValue, yearSearch])

    useEffect(() => {
        if (!hasMounted.current) return;
        if(!isLoadingRef.current) {
            if(page != '1')
                setPage('1');
            else
                getLoungeData();
        }
    }, [radioValue])

    const handleSubmitFilters = (e: any) => {
        if(!isLoadingRef.current) {
            if(page && parseInt(page) > 1) {
                setPage('1');
            }
            else {
                getLoungeData();
            }
        }
    };
    const handleRemoveFilters = (e: any) => {
        if(!isLoading) {

            setLoading(true);

            setRegion(defaultNONE);
            setProvince(defaultNONE);
            setCustomSearch(defaultEMPTY);
            setYearSearch(defaultEMPTY);

            setLoading(false);
            
            setRemoveFilters(true);
        }
    };
    
    useEffect(() => {
        if(!isLoadingRef.current && removeFilters) {
            getLoungeData();
            setRemoveFilters(false);
        }
    }, [removeFilters])

    /*

    * {
        stock.stock_status !== 'STATUS_CLOSED' && (
            <a className="text-danger" href={'#'} onClick={() => handleRemove(item.id, stock.stock_token)}>
                <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18"
                     fill="currentColor" className="bi bi-trash3-fill" viewBox="0 0 16 16">
                    <path d="M11 1.5v1h3.5a.5.5 0 0 1 0 1h-.538l-.853 10.66A2 2 0 0 1 11.115 16h-6.23a2 2 0 0 1-1.994-1.84L2.038 3.5H1.5a.5.5 0 0 1 0-1H5v-1A1.5 1.5 0 0 1 6.5 0h3A1.5 1.5 0 0 1 11 1.5Zm-5 0v1h4v-1a.5.5 0 0 0-.5-.5h-3a.5.5 0 0 0-.5.5ZM4.5 5.029l.5 8.5a.5.5 0 1 0 .998-.06l-.5-8.5a.5.5 0 1 0-.998.06Zm6.53-.528a.5.5 0 0 0-.528.47l-.5 8.5a.5.5 0 0 0 .998.058l.5-8.5a.5.5 0 0 0-.47-.528ZM8 4.5a.5.5 0 0 0-.5.5v8.5a.5.5 0 0 0 1 0V5a.5.5 0 0 0-.5-.5Z"/>
                </svg>
            </a>
        )
    }
    * */

    
    const handleContinueStock = (e: React.MouseEvent<HTMLElement, MouseEvent>, s: any) => {
        e.preventDefault();
        e.stopPropagation();
        

        setAppUniqueToken(s.stock_token);
        setSessionStock(s.stock_name);
        //setSessionStockRegion(regione);
        //setSessionStockProvince(provincia);

        removeNewSessionStock();

        removeCurrentTab();
        removeCurrentQuote();
        removeEmailStorageSent();


        setTimeout(() => {  navigate('/'); }, 250)
    }

    const renderAccordion_v1 = () => {
        return (
            <Accordion> 
            {
                //defaultActiveKey="0">
            }
            {
                data &&
                data?.stocks.data
                     //.filter((x:any) => x.stock_status === radioValue)
                     .map((stock: any, i: number) => (
                        <Accordion.Item key={i.toString()} eventKey={i.toString()}>
                            <Accordion.Header>
                                {
                                    stock.stock_status === 'STATUS_CLOSED' ?
                                        (
                                            <div className="text-success me-2">
                                                <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22"
                                                     fill="currentColor" className="bi bi-cloud-check-fill"
                                                     viewBox="0 0 16 16">
                                                    <path d="M8 2a5.53 5.53 0 0 0-3.594 1.342c-.766.66-1.321 1.52-1.464 2.383C1.266 6.095 0 7.555 0 9.318 0 11.366 1.708 13 3.781 13h8.906C14.502 13 16 11.57 16 9.773c0-1.636-1.242-2.969-2.834-3.194C12.923 3.999 10.69 2 8 2zm2.354 4.854-3 3a.5.5 0 0 1-.708 0l-1.5-1.5a.5.5 0 1 1 .708-.708L7 8.793l2.646-2.647a.5.5 0 0 1 .708.708z"/>
                                                </svg>
                                            </div>
                                        ) :
                                    stock.stock_status === 'STATUS_DELETED' ?
                                        (
                                            <div className="text-danger me-2">
                                                <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22"
                                                     fill="currentColor" className="bi bi-trash3-fill" viewBox="0 0 16 16">
                                                    <path d="M11 1.5v1h3.5a.5.5 0 0 1 0 1h-.538l-.853 10.66A2 2 0 0 1 11.115 16h-6.23a2 2 0 0 1-1.994-1.84L2.038 3.5H1.5a.5.5 0 0 1 0-1H5v-1A1.5 1.5 0 0 1 6.5 0h3A1.5 1.5 0 0 1 11 1.5Zm-5 0v1h4v-1a.5.5 0 0 0-.5-.5h-3a.5.5 0 0 0-.5.5ZM4.5 5.029l.5 8.5a.5.5 0 1 0 .998-.06l-.5-8.5a.5.5 0 1 0-.998.06Zm6.53-.528a.5.5 0 0 0-.528.47l-.5 8.5a.5.5 0 0 0 .998.058l.5-8.5a.5.5 0 0 0-.47-.528ZM8 4.5a.5.5 0 0 0-.5.5v8.5a.5.5 0 0 0 1 0V5a.5.5 0 0 0-.5-.5Z"/>
                                                </svg>
                                            </div>
                                        ) :
                                        (
                                            <div className="text-warning me-2">
                                            <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22"
                                                 fill="currentColor" className="bi bi-exclamation-diamond-fill"
                                                 viewBox="0 0 16 16">
                                                <path d="M9.05.435c-.58-.58-1.52-.58-2.1 0L.436 6.95c-.58.58-.58 1.519 0 2.098l6.516 6.516c.58.58 1.519.58 2.098 0l6.516-6.516c.58-.58.58-1.519 0-2.098L9.05.435zM8 4c.535 0 .954.462.9.995l-.35 3.507a.552.552 0 0 1-1.1 0L7.1 4.995A.905.905 0 0 1 8 4zm.002 6a1 1 0 1 1 0 2 1 1 0 0 1 0-2z"/>
                                            </svg>
                                            </div>
                                        )
                                }
                                <div className="small">
                                     <b>
                                        {
                                            stock.stock_name
                                        }
                                    </b>
                                    &nbsp;&nbsp;
                                    {
                                        data.stock_users 
                                        && (
                                            'da ' 
                                            + data.stock_users.find(k => k.id === stock.created_by)?.name
                                            + ' ' 
                                            + data.stock_users.find(k => k.id === stock.created_by)?.surname
                                        )
                                    }
                                    &nbsp;&nbsp;
                                    {
                                        stock.stock_status === 'STATUS_CLOSED' 
                                        ? (
                                            stock.stock_sent_date
                                            ? moment(stock.stock_sent_date).format(defaultMomentDateFormat)
                                            : moment(stock.stock_date).format(defaultMomentDateFormat)
                                        )

                                        
                                        //moment(stock.stock_sent_date).format(defaultMomentDateFormat)
                                        /*new Date(stock.stock_sent_date).toLocaleDateString(
                                            "it-IT",
                                            {
                                                day: "2-digit",
                                                month: "2-digit",
                                                year: "numeric",
                                            }
                                        )*/
                                        : moment(stock.stock_date).format(defaultMomentDateFormat)
                                        /*new Date(stock.stock_date).toLocaleDateString(
                                            "it-IT",
                                            {
                                                day: "2-digit",
                                                month: "2-digit",
                                                year: "numeric",
                                            }
                                        )*/
                                    }
                                   
                                    {
                                        /*
                                        stock.stock_status === 'STATUS_CLOSED' 
                                        ? stock.stock_sent_date.toString().substring(0,10)
                                        : stock.stock_date.toString().substring(0,10)
                                        */
                                    }

                                    &nbsp;
                                    Numero richieste: &nbsp;{
                                        data.subscriptions 
                                        && Object.values(data.subscriptions[stock.id] || []).length
                                    }
                                    &nbsp;
                                    Valore: &nbsp;{stock.stock_value}
                                </div>
                            </Accordion.Header>
                            <Accordion.Body>
                                <Table size={'sm'} hover={true} responsive={true}>
                                    <thead>
                                    <tr className="small">
                                        <th>#</th>
                                        <th>Nome</th>
                                        <th>Cognome</th>
                                        <th>Codice Fiscale</th>
                                        <th>Città</th>
                                        <th>Quota</th>
                                        <th></th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    {
                                        data.subscriptions && (
                                           Object.values(data.subscriptions[stock.id] || [])
                                                .map((item: any, i: number) => (
                                                        <tr className="small" key={item.id}>
                                                            <td>{ i + 1 }</td>
                                                            <td>{ item.person_name }</td>
                                                            <td>{ item.person_surname }</td>
                                                            <td>{ item.person_fiscal_code }</td>
                                                            <td>{ item.person_town }</td>
                                                            <td>{ item.subscription_value } €</td>
                                                            <td width={40}>

                                                            </td>
                                                        </tr>
                                                    )
                                                )
                                        )
                                    }
                                    <tr className="small" key={'stock_total'}>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                        <td colSpan={2}><b>{t('labels.total')}: { stock.stock_value } €</b></td>
                                    </tr>
                                    {
                                        stock.stock_status === 'STATUS_SAVED'
                                        &&
                                        (
                                            <tr className="small" key={'stock_commands'}>
                                                <td align={'right'} colSpan={7}>
                                                    <a className="btn_1 primary text-white"
                                                       style={{height:'40px', paddingBottom:'5px'}}
                                                       href={'#'}
                                                       onClick={(e) => handleContinueStock(e, stock)}>
                                                    {t('captions.continueThisStock')}</a>
                                                    &nbsp;
                                                    {
                                                        stock.stock_token !== customToken
                                                        && (
                                                            <a className="btn_1 red text-white"
                                                               style={{height:'40px', paddingBottom:'5px'}}
                                                               href={'#'}
                                                               onClick={() => handleTrashStock(stock.id)}>
                                                            {t('captions.delete')}</a>
                                                        )
                                                    }
                                                    &nbsp;
                                                    <a className="btn_1 green text-white"
                                                       style={{height:'40px', paddingBottom:'5px'}}
                                                       href={'#'}
                                                       onClick={() => handleSend(stock.stock_token)}>
                                                    {t('captions.completeSend')}</a>
                                                </td>
                                            </tr>
                                        )
                                    }
                                    {
                                        stock.stock_status === 'STATUS_CLOSED'
                                        && stock.stock_receipt
                                        &&
                                        (
                                            <tr className="small" key={'stock_commands'}>
                                                <td align={'right'} colSpan={7}>
                                                    <a className="btn_1 green text-white"
                                                       style={{height:'40px', paddingBottom:'5px'}}
                                                       href={'/receipts/' + stock.stock_receipt}
                                                       download={stock.stock_receipt}
                                                    >{t('captions.downloadReceipt')}</a>
                                                </td>
                                            </tr>
                                        )
                                    }
                                    </tbody>
                                </Table>
                            </Accordion.Body>
                        </Accordion.Item>
                    )
                )
            }
            </Accordion>
        );
    }

    const renderAccordion_v2 = () => {

        if(!data || !data.stocks) // || !data.stocks.data)
            return <></>;
        
        const groupedByRegion = data.stocks.reduce((acc: any, stock: any) => {
            const region = stock.stock_region_code;
            if (!acc[region]) {
                acc[region] = [];
            }
            acc[region].push(stock);
            return acc;
        }, {});

        // Object.keys(groupedByRegion).forEach(region => {
        //     groupedByRegion[region].sort((a: any, b: any) => a.name.localeCompare(b.name));
        // });

        // Object.keys(groupedByRegion).forEach(region => {
        //     groupedByRegion[region].sort((a: any, b: any) => a.user_surname.localeCompare(b.user_surname));
        // });

        // console.log(groupedByRegion);
        // console.log(data.subscriptions);

        let m = (
            <Accordion>
                {
                    groupedByRegion
                        && Object.keys(groupedByRegion).map((region, i) => (    
                            <Accordion.Item eventKey={i.toString()}>
                                <Accordion.Header>
                                    {/* <div className="text-success me-2">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20"
                                                fill="currentColor" className="bi bi-person-fill-check"
                                                viewBox="0 0 16 16">
                                            <path
                                                d="M12.5 16a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7Zm1.679-4.493-1.335 2.226a.75.75 0 0 1-1.174.144l-.774-.773a.5.5 0 0 1 .708-.708l.547.548 1.17-1.951a.5.5 0 1 1 .858.514ZM11 5a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z"/>
                                            <path
                                                d="M2 13c0 1 1 1 1 1h5.256A4.493 4.493 0 0 1 8 12.5a4.49 4.49 0 0 1 1.544-3.393C9.077 9.038 8.564 9 8 9c-5 0-6 3-6 4Z"/>
                                        </svg>
                                    </div> */}
                                    { 
                                        (
                                            decodeRegione(region) != ''
                                            ? decodeRegione(region)
                                            : 'Regione non specificata'
                                        ) + ' - Stock inviati: ' + groupedByRegion[region].length
                                    }
                                </Accordion.Header>
                                <Accordion.Body>
                                    <Accordion flush>
                                    {
                                        groupedByRegion[region]
                                        .map((stock: any, ii: number) => (
                                            <Accordion.Item key={ii.toString()} eventKey={ii.toString()}>
                                                <Accordion.Header>
                                                    {
                                                        stock.stock_status === 'STATUS_CLOSED' ?
                                                            (
                                                                <div className="text-success me-2">
                                                                    <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22"
                                                                         fill="currentColor" className="bi bi-cloud-check-fill"
                                                                         viewBox="0 0 16 16">
                                                                        <path d="M8 2a5.53 5.53 0 0 0-3.594 1.342c-.766.66-1.321 1.52-1.464 2.383C1.266 6.095 0 7.555 0 9.318 0 11.366 1.708 13 3.781 13h8.906C14.502 13 16 11.57 16 9.773c0-1.636-1.242-2.969-2.834-3.194C12.923 3.999 10.69 2 8 2zm2.354 4.854-3 3a.5.5 0 0 1-.708 0l-1.5-1.5a.5.5 0 1 1 .708-.708L7 8.793l2.646-2.647a.5.5 0 0 1 .708.708z"/>
                                                                    </svg>
                                                                </div>
                                                            ) :
                                                        stock.stock_status === 'STATUS_DELETED' ?
                                                            (
                                                                <div className="text-danger me-2">
                                                                    <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22"
                                                                         fill="currentColor" className="bi bi-trash3-fill" viewBox="0 0 16 16">
                                                                        <path d="M11 1.5v1h3.5a.5.5 0 0 1 0 1h-.538l-.853 10.66A2 2 0 0 1 11.115 16h-6.23a2 2 0 0 1-1.994-1.84L2.038 3.5H1.5a.5.5 0 0 1 0-1H5v-1A1.5 1.5 0 0 1 6.5 0h3A1.5 1.5 0 0 1 11 1.5Zm-5 0v1h4v-1a.5.5 0 0 0-.5-.5h-3a.5.5 0 0 0-.5.5ZM4.5 5.029l.5 8.5a.5.5 0 1 0 .998-.06l-.5-8.5a.5.5 0 1 0-.998.06Zm6.53-.528a.5.5 0 0 0-.528.47l-.5 8.5a.5.5 0 0 0 .998.058l.5-8.5a.5.5 0 0 0-.47-.528ZM8 4.5a.5.5 0 0 0-.5.5v8.5a.5.5 0 0 0 1 0V5a.5.5 0 0 0-.5-.5Z"/>
                                                                    </svg>
                                                                </div>
                                                            ) :
                                                            (
                                                                <div className="text-warning me-2">
                                                                <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22"
                                                                     fill="currentColor" className="bi bi-exclamation-diamond-fill"
                                                                     viewBox="0 0 16 16">
                                                                    <path d="M9.05.435c-.58-.58-1.52-.58-2.1 0L.436 6.95c-.58.58-.58 1.519 0 2.098l6.516 6.516c.58.58 1.519.58 2.098 0l6.516-6.516c.58-.58.58-1.519 0-2.098L9.05.435zM8 4c.535 0 .954.462.9.995l-.35 3.507a.552.552 0 0 1-1.1 0L7.1 4.995A.905.905 0 0 1 8 4zm.002 6a1 1 0 1 1 0 2 1 1 0 0 1 0-2z"/>
                                                                </svg>
                                                                </div>
                                                            )
                                                    }
                                                    <div className="small">
                                                        <b>{ stock.stock_name }</b>
                                                        &nbsp;&nbsp;
                                                        {
                                                             'da ' 
                                                             + stock.user_name
                                                             + ' ' 
                                                             + stock.user_surname
                                                        }
                                                        &nbsp;&nbsp;
                                                        {
                                                            stock.stock_status === 'STATUS_CLOSED' 
                                                            ? (
                                                                stock.stock_sent_date
                                                                ? moment(stock.stock_sent_date).format(defaultMomentDateFormat)
                                                                : moment(stock.stock_date).format(defaultMomentDateFormat)
                                                            )
                    
                                                            
                                                            //moment(stock.stock_sent_date).format(defaultMomentDateFormat)
                                                            /*new Date(stock.stock_sent_date).toLocaleDateString(
                                                                "it-IT",
                                                                {
                                                                    day: "2-digit",
                                                                    month: "2-digit",
                                                                    year: "numeric",
                                                                }
                                                            )*/
                                                            : moment(stock.stock_date).format(defaultMomentDateFormat)
                                                            /*new Date(stock.stock_date).toLocaleDateString(
                                                                "it-IT",
                                                                {
                                                                    day: "2-digit",
                                                                    month: "2-digit",
                                                                    year: "numeric",
                                                                }
                                                            )*/
                                                        }
                                                       
                                                        {
                                                            /*
                                                            stock.stock_status === 'STATUS_CLOSED' 
                                                            ? stock.stock_sent_date.toString().substring(0,10)
                                                            : stock.stock_date.toString().substring(0,10)
                                                            */
                                                        }
                    
                                                        &nbsp;
                                                        Numero richieste: &nbsp;{
                                                            data.subscriptions
                                                                && Object.values(data.subscriptions[stock.id] || []).length
                                                        }
                                                        &nbsp;
                                                        Valore: &nbsp;{stock.stock_value}
                                                    </div>
                                                </Accordion.Header>
                                                <Accordion.Body>
                                                    <Table size={'sm'} hover={true} responsive={true}>
                                                        <thead>
                                                        <tr className="small">
                                                            <th>#</th>
                                                            <th>Nome</th>
                                                            <th>Cognome</th>
                                                            <th>Codice Fiscale</th>
                                                            <th>Città</th>
                                                            <th>Quota</th>
                                                            <th></th>
                                                        </tr>
                                                        </thead>
                                                        <tbody>
                                                        {
                                                            data.subscriptions 
                                                            && (
                                                                Object.values(data.subscriptions[stock.id] || [])
                                                                    .map((item: any, i: number) => (
                                                                            <tr className="small" key={item.id}>
                                                                                <td>{ i + 1 }</td>
                                                                                <td>{ item.person_name }</td>
                                                                                <td>{ item.person_surname }</td>
                                                                                <td>{ item.person_fiscal_code }</td>
                                                                                <td>{ item.person_town }</td>
                                                                                <td>{ item.subscription_value } €</td>
                                                                                <td width={40}></td>
                                                                            </tr>
                                                                        )
                                                                    )
                                                            )
                                                        }
                                                        <tr className="small" key={'stock_total'}>
                                                            <td></td>
                                                            <td></td>
                                                            <td></td>
                                                            <td></td>
                                                            <td></td>
                                                            <td colSpan={2}><b>{t('labels.total')}: { stock.stock_value } €</b></td>
                                                        </tr>
                                                        {
                                                            stock.stock_status === 'STATUS_SAVED'
                                                            &&
                                                            (
                                                                <tr className="small" key={'stock_commands'}>
                                                                    <td align={'right'} colSpan={7}>
                                                                        <a className="btn_1 primary text-white"
                                                                           style={{height:'40px', paddingBottom:'5px'}}
                                                                           href={'#'}
                                                                           onClick={(e) => handleContinueStock(e, stock)}>
                                                                        {t('captions.continueThisStock')}</a>
                                                                        &nbsp;
                                                                        {
                                                                            stock.stock_token !== customToken
                                                                            && (
                                                                                <a className="btn_1 red text-white"
                                                                                   style={{height:'40px', paddingBottom:'5px'}}
                                                                                   href={'#'}
                                                                                   onClick={() => handleTrashStock(stock.id)}>
                                                                                {t('captions.delete')}</a>
                                                                            )
                                                                        }
                                                                        &nbsp;
                                                                        <a className="btn_1 green text-white"
                                                                           style={{height:'40px', paddingBottom:'5px'}}
                                                                           href={'#'}
                                                                           onClick={() => handleSend(stock.stock_token)}>
                                                                        {t('captions.completeSend')}</a>
                                                                    </td>
                                                                </tr>
                                                            )
                                                        }
                                                        {
                                                            stock.stock_status === 'STATUS_CLOSED'
                                                            && stock.stock_receipt
                                                            &&
                                                            (
                                                                <tr className="small" key={'stock_commands'}>
                                                                    <td align={'right'} colSpan={7}>
                                                                        <a className="btn_1 green text-white"
                                                                           style={{height:'40px', paddingBottom:'5px'}}
                                                                           href={'/receipts/' + stock.stock_receipt}
                                                                           download={stock.stock_receipt}
                                                                        >{t('captions.downloadReceipt')}</a>
                                                                    </td>
                                                                </tr>
                                                            )
                                                        }
                                                        </tbody>
                                                    </Table>
                                                </Accordion.Body>
                                            </Accordion.Item>
                                        ))
                                    }
                                    </Accordion>
                                </Accordion.Body>
                            </Accordion.Item>
                        ))
                }
            </Accordion>
        );

        return (m);
    }

    return (
        isLoading ?
            <LoadingSpinner />
            :
            <>
                <SendConfirmation show={showSendModal} onHide={() => setShowSendModal(false)} />
                <RemoveConfirmation elementType={'stock'}
                                    show={showRemoveModal}
                                    onHide={() => setShowRemoveModal(false)}
                                    customID={customID}
                                    customToken={customToken} />
                
                <Container fluid className="p-0 m-0">
                    <Row className={'mb-2'}>
                        <Col sm={12} md={4} lg={4} className={'mb-2'}>
                        <ButtonGroup>
                            {
                                radios.map((radio, idx) => (
                                    <ToggleButton
                                        key={idx}
                                        id={`radio-${idx}`}
                                        type="radio"
                                        variant={
                                            radio.value === 'STATUS_SAVED' ? 'outline-warning'
                                            : radio.value === 'STATUS_CLOSED' ? 'outline-success' : 'outline-danger'}
                                        name="radio"
                                        value={radio.value}
                                        checked={radioValue === radio.value}
                                        onChange={(e) => handleOnChangeStatus(e)}
                                    >
                                        {radio.name}
                                    </ToggleButton>
                                ))
                            }
                        </ButtonGroup>
                        </Col>
                        <Col sm={12} md={8} lg={8} className={'mb-2'}>

                            {
                                user && user.user.role !== 'ROLE_USER' && (
                                    <Form noValidate onSubmit={e => handleSubmitFilters(e)}>
                                    <Row className="mb-2">
                                        <Col>
                                            <Form.Select
                                                value={region}
                                                onChange={e => setRegion(e.target.value)}
                                            >
                                            <option key={defaultNONE} value={defaultNONE}>{t('labels.region')}</option>
                                            <option key={'disabled-' + defaultNONE} value={'disabled-' + defaultNONE} disabled></option>
                                            {
                                                jsonRegion.map(({id_regione, regione}, idx) => (
                                                    <option key={'REG' + idx} value={id_regione}>{regione}</option>
                                                ))
                                            }
                                            </Form.Select>
                                        </Col>
                                        <Col>
                                            <Form.Select
                                                value={province}
                                                onChange={e => setProvince(e.target.value)}
                                            >
                                            <option key={defaultNONE} value={defaultNONE}>{t('labels.province')}</option>
                                            <option key={'disabled-' + defaultNONE} value={'disabled-' + defaultNONE} disabled></option>
                                            {
                                                jsonProvince.map(({sigla, provincia, id_regione}, idx) => (
                                                    <option key={'PRV' + idx} value={sigla} >{provincia}</option>
                                                ))
                                            }
                                            </Form.Select>
                                        </Col>
                                        <Col>

                                            <Form.Select
                                                value={yearSearch}
                                                onChange={e => setYearSearch(e.target.value)}
                                            >
                                            <option key={defaultNONE} value={defaultNONE}>{t('labels.year')}</option>
                                            <option key={'disabled-' + defaultNONE} value={'disabled-' + defaultNONE} disabled></option>
                                            {
                                                getLastYearsOptions(3).map((x, idx) => (
                                                    <option key={"Y" + x} value={x}>{x}</option>
                                                )
                                            )}
                                            </Form.Select>

                                        {/* <Form.Control
                                            type="text"
                                            placeholder="Anno"
                                            aria-label="Anno"
                                            value={yearSearch}
                                            onChange={e => setYearSearch(e.target.value)}
                                        /> */}
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col>
                                            <InputGroup>
                                                <Form.Control
                                                    type="text"
                                                    placeholder="Nome della sessione o Tesseratore"
                                                    aria-label="Nome della sessione o Tesseratore"
                                                    value={customSearch}
                                                    onChange={e => setCustomSearch(e.target.value)}
                                                />
                                                {
                                                    showRemoveFiltersButton
                                                    && (
                                                        <Button variant="outline-danger" onClick={(e) => handleRemoveFilters(e)}>{t('captions.cancel')}</Button>
                                                    )
                                                }
                                                <Button type={'submit'} variant="outline-success">{t('captions.search')}</Button>
                                            </InputGroup>
                                        </Col>
                                    </Row>
                                    </Form>
                                )
                            }

                        </Col>
                    </Row>
                </Container>
                
                <div>
                { 
                    t('captions.found') 
                    + ' ' 
                    + data?.stocks.length 
                    //+ data?.stocks.data
                    //    .filter((x:any) => x.stock_status === radioValue)
                    //    .length
                    + ' ' 
                    + t('captions.results') 
                }
                </div>
                
                { renderAccordion_v2() }
                
                {
                    /*
                <div>
                    Showing {data?.stocks.from} to {data?.stocks.to} from {data?.stocks.total} results.
                </div>
                    */
                }
                {
                    /*         
                <div className="mt-2">
                    {
                        (data?.stocks.next_page_url || data?.stocks.prev_page_url)
                        && renderPaginationLinks()
                    }
                </div>
                    */
                }
            </>
    );
};

export default SubscriptionsAccordion;
